import React from 'react';
import { AbandonCheckout } from 'src/constrains/AdvancedFilters/Components';

// radioName,
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/CustomerDatabaseConfig/CustomerTag/Detail/Filters/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import { IntClear } from '../Components';

const _AbandonCheckout = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { radioName, root, state, form, disabled } = props;
  return (
    <SectionWrapper
      title={getI18n('customerTag.abandonCheckout.abandonedcheckout')}>
      <ItemWrapper title=''>
        <AbandonCheckout radioName={radioName} disabled={disabled} />
        <IntClear
          form={form}
          root={root}
          value={radioName}
          state={state}
          disabled={disabled}
        />
      </ItemWrapper>
    </SectionWrapper>
  );
};
export default _AbandonCheckout;
